export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-gray-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-black text-gray-900">关于我们</h2>
            <p className="text-sm text-gray-500 mt-2">了解90影视的初心与坚持</p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="bg-white rounded-2xl p-8 md:p-12 border border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-xl bg-brand-50 flex items-center justify-center">
                  <i className="ri-movie-2-line text-brand-600 text-lg w-5 h-5 flex items-center justify-center"></i>
                </div>
                <span className="text-xl font-black text-gray-900">90影视</span>
              </div>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                90影视成立于2020年，是国内领先的免费在线影视观看平台。我们致力于为广大影视爱好者提供
                <strong>免费、高清、无广告</strong>的观影服务。平台汇聚了海量电影、电视剧、综艺、动漫资源，
                覆盖华语、日韩、欧美等多元内容类型，满足不同用户的观影需求。
              </p>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                我们坚持<strong>每日更新</strong>最新资源，采用先进的视频编码技术和CDN加速，
                确保用户在任何网络环境下都能享受<strong>流畅不缓冲</strong>的观影体验。
                自上线以来，90影视已累计服务超过千万用户，成为省钱追剧的首选平台。
              </p>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                未来，90影视将继续拓展内容版图，优化播放体验，让更多人能够轻松享受高质量的影视内容。
                我们相信，好的内容值得被更多人看到。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}